/* eslint-disable react/no-danger */
import React, { memo, useContext } from 'react';

import { AppContext } from 'src/components/app-context';
import type { ParamsAndReturnTypes } from './translate-func';

function sanitizeParamForMarkdown(param: any) {
  return param
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function sanitizeParamsForMarkdown(params: object) {
  return Object.keys(params).reduce(
    (sanitizedParams, key) => ({
      ...sanitizedParams,
      [key]: sanitizeParamForMarkdown(params[key]),
    }),
    {}
  );
}

function getTextFromNode(node: React.ReactNode) {
  if (typeof node === 'string') return node;

  return '';
}

interface TranslateProps {
  domain: keyof ParamsAndReturnTypes;
  children: React.ReactNode;
  [x: string]: any;
}

export const Translate: React.FC<TranslateProps> = memo(
  ({ domain, children, ...params }) => {
    const { t } = useContext(AppContext);

    if (!t) {
      return <span>{children}</span>;
    }

    const childrenText = getTextFromNode(children);
    const isMarkdown = childrenText && childrenText.slice(-3) === '.md';

    const text = t(
      domain,
      // @ts-expect-error expects never for some reason
      childrenText,
      isMarkdown ? sanitizeParamsForMarkdown(params) : params
    ) as string;

    return isMarkdown ? (
      <span dangerouslySetInnerHTML={{ __html: text }} />
    ) : (
      <span>{text}</span>
    );
  }
);
